<template>
  <div>
    <h6 v-if="screenWidth < 992" class="filter-mobile-title">
      <span>
        {{ result.messages.catalog }}
      </span>
    </h6>

    <CatalogAsideMenu v-if="options && options.showAsideMenu && !showShortFilter" />
    <CancelFilterInline
      v-if="showShortFilter"
      :result="result"
      @handlerChangeData="$emit('changeFilter')"
      @resetFilter="$emit('resetFilter', $event)"
    />
    <div v-show="!showShortFilter" class="catalog-filter">
      <form id="filter" ref="filter-form" class="catalog-filter__color filter">
        <input v-for="item in result.hidden" :name="item.name" :value="item.value" type="hidden" />
        <CancelFilter
          :result="result"
          @handlerChangeData="$emit('changeFilter')"
          @resetFilter="$emit('resetFilter', $event)"
        />

        <div v-for="item in result.ITEMS">
          <div v-if="item.DISPLAY_TYPE === 'A'">
            <div v-if="item.CODE === 'VSTAVKA_SIZE'" class="filter-block">
              <div class="filter-block__header catalog-filter__search-input" @click="open = !open">
                <h6 class="filter-block__title">
                  {{ item.NAME }}
                  <!--                  <DefInformText v-if="result?.PRINT_FILTER_HINT" parent=".catalog-top .vue-popup__content">-->
                  <!--                    <template #content>-->
                  <!--                      <span v-html="result?.PRINT_FILTER_HINT" />-->
                  <!--                    </template>-->
                  <!--                    <svg width="24" height="24"><use xlink:href="#svg-question"></use></svg>-->
                  <!--                  </DefInformText>-->
                </h6>
                <div class="def-plus">
                  <div></div>
                  <div :class="{ 'def-plus__close': open }"></div>
                </div>
              </div>
              <SlideUpDown :model-value="open">
                <div class="filter-range filter-block__filters">
                  <input
                    :id="item.VALUES.MIN.CONTROL_ID"
                    class="filter-range__input"
                    type="number"
                    :name="item.VALUES.MIN.CONTROL_NAME"
                    :value="item.VALUES.MIN.HTML_VALUE"
                    :placeholder="item.VALUES.MIN.VALUE"
                  />
                  <input
                    :id="item.VALUES.MIN.CONTROL_ID"
                    class="filter-range__input"
                    type="number"
                    :name="item.VALUES.MAX.CONTROL_NAME"
                    :value="item.VALUES.MAX.HTML_VALUE"
                    :placeholder="item.VALUES.MAX.VALUE"
                  />
                  <span class="filter-range__button" @click="$emit('changeFilter')"> ОК </span>
                </div>
              </SlideUpDown>
            </div>
            <div v-else>
              <h6 class="catalog-filter__title">{{ item.NAME }}</h6>
              <div class="filter-range">
                <input
                  :id="item.VALUES.MIN.CONTROL_ID"
                  class="filter-range__input"
                  type="number"
                  :name="item.VALUES.MIN.CONTROL_NAME"
                  :value="item.VALUES.MIN.HTML_VALUE"
                  :placeholder="item.VALUES.MIN.VALUE"
                />
                <input
                  :id="item.VALUES.MIN.CONTROL_ID"
                  class="filter-range__input"
                  type="number"
                  :name="item.VALUES.MAX.CONTROL_NAME"
                  :value="item.VALUES.MAX.HTML_VALUE"
                  :placeholder="item.VALUES.MAX.VALUE"
                />
                <span class="filter-range__button" @click="$emit('changeFilter')"> ОК </span>
              </div>
              <hr class="catalog-filter__line" />
            </div>
          </div>
          <div v-else>
            <FilterBlock v-if="item.CODE !== 'BASE'" :result="item" />
          </div>
        </div>
        <div class="catalog-filter__buttons_wrapper">
          <button
            v-if="result.messages.accept"
            type="button"
            class="def-button catalog-filter__button"
            @click="$emit('changeFilter')"
          >
            {{ result.messages.accept }}
          </button>
          <button
            type="reset"
            class="def-button catalog-filter__button"
            @click.prevent="$emit('resetFilter', result.actions.resetFilter.link)"
          >
            {{ result.actions.resetFilter.text }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CatalogAsideMenu from '@components/Catalog/CatalogAsideMenu.vue';
import CancelFilterInline from '@components/Catalog/filter/CancelFilterInline.vue';
import CancelFilter from '@components/Catalog/filter/CancelFilter.vue';
import FilterBlock from '@components/Catalog/filter/FilterBlock.vue';
import SlideUpDown from 'vue3-slide-up-down';
import { screenWidth } from '@use/useDeviceInfo';

export default {
  name: 'CatalogFilter',
  components: { FilterBlock, CancelFilter, CancelFilterInline, CatalogAsideMenu, SlideUpDown },
  props: {
    result: {
      type: Object,
    },
    showShortFilter: {
      type: Boolean,
    },
    options: {
      type: Object,
      default: () => ({
        showAsideMenu: false,
      }),
    },
  },
  data() {
    return {
      screenWidth,
      open: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.catalog-filter {
  position: relative;
  &__color {
    padding: 14px 14px 69px;
    background-color: #ffffff;
    @include point-lg {
      padding: 32px;
    }
  }

  &__button {
    margin-top: 10px;
    &:first-child {
      margin-right: 15px;
      @include point-lg {
        margin-right: 0;
      }
    }
  }

  &__buttons_wrapper {
    display: flex;
    justify-content: center;
    gap: 10px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    padding: 0 24px 10px;
    border-top: 1px solid #dfdfdf;
    @include point-lg {
      position: sticky;
      left: -14px;
      right: -14px;
      padding: 0 0 10px;
    }
  }

  &__line {
    margin: 24px 0;
    border-top: none;
    border-bottom-color: #dfdfdf;
  }

  &__title {
    font-weight: 500;
    font-size: rem(12);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #191918;
    margin-bottom: 16px;
    @include point-md {
      font-size: rem(14);
    }
  }
  &__search-input {
    margin-bottom: 21px;
  }
}
.filter-range {
  display: flex;

  &__input {
    width: 100%;
    max-width: 73px;
    height: 32px;
    flex-grow: 2;
    padding: 0 7px;
    border: 1px solid #dfdfdf;
    margin-right: 8px;
    font-size: rem(16);
    color: #757575;
    @include point-md {
      max-width: 96px;
    }
    @include point-lg {
      max-width: 70px;
    }
    @include point-xl {
      max-width: 96px;
    }
  }

  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: rem(14);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #ffffff;
    background: var(--border-colour-primary);
    flex-grow: 1;

    &:hover {
      cursor: pointer;
    }
  }
}
.filter-mobile-title {
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 24px;
  box-shadow: 0px 4px 5px rgba(47, 76, 120, 0.1);
  position: relative;
  z-index: 1;
  font-weight: 500;
  font-size: rem(14);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-colour-primary);
  margin-bottom: 10px;
  @include point-md {
    font-size: rem(16);
    padding: 0 34px;
  }
}
.filter-links {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  color: var(--text-colour-primar);
  text-transform: uppercase;
  border-bottom: 1px solid #dfdfdf;
  padding-bottom: 20px;
  font-size: 0.75rem;
  @include point-md {
    font-size: 0.875rem;
  }

  &__items {
    padding-left: 32px;
  }

  &__item {
    &:not(:last-child) {
      margin-bottom: 10px;
    }

    &_active {
      color: var(--discount-color);
    }
  }

  &__title {
    font-weight: 500;
    letter-spacing: 0.08em;
    margin-bottom: 21px;
  }
}
</style>
